import { render, staticRenderFns } from "./editsenderaddress.vue?vue&type=template&id=8940fc3e"
import script from "./editsenderaddress.vue?vue&type=script&lang=js"
export * from "./editsenderaddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports